export const PRODUCT_STATUS_PENDING  = 'pending'
export const PRODUCT_STATUS_NORMAL   = 'normal'
export const PRODUCT_STATUS_FLOOR    = 'floor'
export const PRODUCT_STATUS_ROOF     = 'roof'
export const PRODUCT_STATUS_CHECKING = 'checking'
export const PRODUCT_STATUS_ERROR    = 'error'